module.exports = require("./shi-Tfng-MA.js");